<template>
    <div class="box">
        <div class="title">{{ title }}</div>
        <div class="count">{{ (number || 0) | numberFormat(4)}}</div>
        <div class="bottom">
            今日
            <span v-if="today >= 0" class="up-count"><a-icon type="arrow-up" class="array"/>{{today || 0}}</span>
            <span v-if="today < 0" class="down-count"><a-icon type="arrow-down" class="array"/>{{today || 0}}</span>
            昨日
            <span v-if="yestoday < 0" class="down-count"><a-icon type="arrow-down" class="array"/>{{yestoday || 0}}</span>
            <span v-if="yestoday >= 0" class="up-count"><a-icon type="arrow-up" class="array"/>{{yestoday || 0}}</span>
        </div>
        <img class="icon" :src="title === '站点总数' ? require('../img/allCount.png') : require('../img/allResult.png')" alt="">
    </div>
</template>

<script>
  export default {
    name: 'overviewBox',
    props: {
      title: String,
      number: {
        type: Number,
        default: 0
      },
      today: {
        type: Number,
        default: 0
      },
      yestoday: {
        type: Number,
        default: 0
      },
    }
  }
</script>

<style scoped lang="less">
.box{
    height: 160px;
    background: #fff;
    border-radius: 4px;
    padding: 20px 30px;
    position: relative;
    .title{
        font-size: 16px;
        color: #999;
    }
    .count{
        font-size: 36px;
        color: #333;
        margin-top: 5px;
    }
    .bottom{
        font-size: 12px;
        margin-top: 15px;
    }
    .icon{
        width: 64px;
        height: 64px;
        position: absolute;
        top: 50%;
        right: 25px;
        margin-top: -32px;
    }
    .array{
        position: relative;
        top: 3px;
    }
    .up-count{
        color: #4683FF;
        padding-right: 10px;
        .array{
            transform:rotate(-45deg);
            padding-left:5px;
        }
    }
    .down-count{
        color:#FD7171;
        .array{
            transform:rotate(-45deg);
            padding-left:5px;
        }
    }
}
</style>
